import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Col, InputNumber, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { getLastDayOfCurrentMonth } from '../../../services/util/date';
import LabelValue from '../../atoms/LabelValue';
import CustomModal from '../../molecules/Modal';

function ModalApproveReopening({ open, onCancelClick, onConfirmClick, benefitOrder }) {
  const currentDay = new Date().getDate();
  const [startDay, setStartDay] = useState(currentDay);
  const [endDay, setEndDay] = useState();
  const lastDayOfCurrentMonth = getLastDayOfCurrentMonth();

  return (
    <CustomModal
      title="Aprovar Alteração do Período"
      okText="Confirmar"
      cancelText="Cancelar"
      onCancel={onCancelClick}
      width={400}
      okButtonProps={{
        disabled: !endDay || !startDay,
      }}
      onOk={() => onConfirmClick({ startDay, endDay })}
      open={open}
      afterClose={() => {
        setStartDay(currentDay);
        setEndDay();
      }}
    >
      <LabelValue
        label="Justificativa do Gestor"
        value={benefitOrder && benefitOrder.reopeningJustification}
        size="small"
      />
      <br />
      <Row
        type="flex"
        gutter={[16, 16]}
      >
        <Col flex={1}>
          <Label label="Dia inicial do período">
            <InputNumber
              value={startDay}
              min={currentDay}
              max={lastDayOfCurrentMonth}
              style={{ width: '160px' }}
              placeholder={`${currentDay} - ${lastDayOfCurrentMonth}`}
              onChange={(value) => setStartDay(value)}
            />
          </Label>
        </Col>
        <Col flex={1}>
          <Label label="Dia final do período">
            <InputNumber
              value={endDay}
              min={startDay || currentDay}
              max={lastDayOfCurrentMonth}
              style={{ width: '160px' }}
              placeholder={`${startDay || currentDay} - ${lastDayOfCurrentMonth}`}
              onChange={(value) => setEndDay(value)}
            />
          </Label>
        </Col>
      </Row>
    </CustomModal>
  );
}

ModalApproveReopening.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  benefitOrder: PropTypes.shape,
};

ModalApproveReopening.defaultProps = {
  benefitOrder: undefined,
};

export default ModalApproveReopening;
